import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdShoppingCart, MdLayers } from "react-icons/md";

import styles from "./FloatingCarts.module.scss";
import { selectCartItems } from "../../../store/slices/cartSlice";
import { CART_ROUTE, COMPLEX_CART_ROUTE } from "../../utils/constants";

export const FloatingCarts: React.FC = () => {
  const navigate = useNavigate();
  const cartItems = useSelector(selectCartItems);
  const complexItems = useSelector(
    (state: any) => state.complexOrderCart.items,
  );

  const cartCount = cartItems.reduce((s, i) => s + i.quantity, 0);
  const complexCount = complexItems.reduce(
    (s: number, i: any) => s + i.quantity,
    0,
  );

  return (
    <div className={styles.container}>
      <button
        className={styles.button}
        onClick={() => navigate(CART_ROUTE)}
        aria-label="Корзина"
      >
        <MdShoppingCart size={24} />
        {cartCount > 0 && <span className={styles.badge}>{cartCount}</span>}
      </button>

      <button
        className={styles.button}
        onClick={() => navigate(COMPLEX_CART_ROUTE)}
        aria-label="Комплексы"
      >
        <MdLayers size={24} />
        {complexCount > 0 && (
          <span className={styles.badge}>{complexCount}</span>
        )}
      </button>
    </div>
  );
};
